import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import ClientLayout from "../components/layout/ClientLayout";
import Bootstrap4DatePickerComponent from "../components/Bootstrap4DatePickerComponent";
import "../../../assets/bp/BPEXCH-style.css";
import axiosInstance from "../../../utils/axiosInstance";
import { utils, writeFile } from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import { isMobile } from "react-device-detect";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import { useSelector } from "react-redux";
import ReactDOM1 from "react-dom/client";
import BetDetailsPopup from "./BetDetailsPopup";

const AccountStatement = () => {
  const printRef = useRef(null);
  const [uniqueGridKey, setUniqueGridKey] = useState(Date.now());
  const [statement, setStatement] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);

  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = true;

  const showDescription = (data, row) => {
    let marketTypeTxt = "";
    if (row.market_type == 2) {
      marketTypeTxt = "/Bookmaker";
    } else if (row.market_type == 1) {
      marketTypeTxt = "/Match Odd";
    } else if (row.market_type == 5) {
      marketTypeTxt = "/Tie";
    } else if (row.market_type == 6) {
      marketTypeTxt = "/Figure";
    } else if (row.market_type == 8) {
      marketTypeTxt = "/EvenOdd";
    } else if (row.market_type == 3) {
      marketTypeTxt = "/Fancy";
    }

    if (data === "Opening Balance") {
      return `<span style='color:#4dbd74;font-weight:semibold;font-size:1rem'>${data}</span>`;
    }

    const resultTxt = row.result ? ` [${row.result}]` : "";
    //const label = `${row.description}${marketTypeTxt}${resultTxt}`;
    const label = `${row.description}${marketTypeTxt}`;

    if (Number(row.voided) === 1) {
      return `<a href="javascript:void(0)" onClick="showBetDetails('${row.id}',${row.game_type},${row.user_role},${row.type})" class="text-muted ledger-row-voided">
      ${label} (Canceled)</a>`;
    }

    return `<a href="javascript:void(0)" style='color:#00b181;font-weight:semibold;font-size:1rem' onClick="showBetDetails('${row.id}',${row.game_type},${row.user_role},${row.type})">
      ${label}</a>`;
  };

  const cols = useMemo(
    () => [
      {
        title: "#",
        data: "seq",
        orderable: true,
        className: "dt-center",
        width: "8%",
        responsivePriority: 1,
        render: (data, type, row, meta) => {
          if (type === "display" || type === "filter") {
            return `
              <div class="seq-cell">
              <button type="button" class="toggle-row toggle-closed">+</button>
                <span class="seq-number" style="padding-left:10px">${data}</span>
                
              </div>
            `;
          }
          return data;
        }
      },
      {
        title: "Date",
        data: "date",
        width: "18%",
        className: "dt-right",
        // After Description so on narrow screens # + Date + Description stay visible; Amount/Balance move to expanded details
        responsivePriority: 2,
        render: (d, type) => {
          if (type === "display" || type === "filter") {
            if (!d) return "";
            const dt = new Date(d);
            const datePart = dt.toLocaleDateString(undefined, {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            });
            const fullTime = dt.toLocaleTimeString(undefined, {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
            // Split "04:47 pm" into time "04:47" and meridiem "pm"
            const meridiemMatch = fullTime.match(/^([\d:]+)\s*(am|pm)$/i);
            if (meridiemMatch) {
              const hhmm = meridiemMatch[1];
              const meridiem = meridiemMatch[2];
              return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem">${hhmm} ${meridiem}</span> </span>`;
            }
            return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem">${fullTime}</span></span></span>`;
          }
          return d ? new Date(d).getTime() : 0;
        }
      },
      {
        title: "Description",
        data: "description",
        width: "44%",
        render: (data, type, row, meta) => showDescription(data, row),
        responsivePriority: 3
      },
      {
        title: "Amount",
        data: "amount",
        width: "15%",
        render: (d, type, row) => {
          if (Number(row?.voided) === 1) {
            return `<span class="ledger-row-voided" style="font-size:1rem">${formatTruncate(
              d
            )}</span>`;
          }
          return `<span style="font-size:1rem" class="">${formatTruncate(
            d
          )}</span>`;
        },
        responsivePriority: 10001
      },

      {
        title: "Balance",
        data: "balance",
        width: "15%",
        render: (d, type, row) => {
          if (Number(row?.voided) === 1) {
            return `<span class="ledger-row-voided" style="font-size:1rem">${formatTruncate(
              d
            )}</span>`;
          }
          return `<span style="font-size:1rem" class="">${formatTruncate(
            d
          )}</span>`;
        },
        responsivePriority: 10002
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "type",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "game_type",
        data: "game_type",
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 7,
        visible: false
      },
      {
        title: "market_type",
        data: "market_type",
        render: (d) => `<span>${d}</span>`,
        visible: false,
        responsivePriority: 8
      }
    ],
    []
  );

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const openLedgerPopUp = async (id, game_type) => {
    if (game_type == 9) {
      const popup = window.open(
        "/client-virtual-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 6) {
      const popup = window.open(
        "/client-casino-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 7 || game_type == 10) {
      const popup = window.open(
        "/client-tp-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else {
      const popup = window.open(
        "/clinet-bet-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    }
  };

  const openCreditDebitDetailsPopUp = async (id) => {
    const popup = window.open(
      "/credit-debit-popup-details/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  useEffect(() => {
    window.showBetDetails = (id, game_type, user_role, type) => {
      if (type == 3) {
        openCreditDebitDetailsPopUp(id);
      } else {
        openLedgerPopUp(id, game_type);
      }
    };

    return () => {
      // clean up when react component unmounts. It will clean it from the memory when we will navigate to other component or page.
      delete window.showBetDetails;
    };
  }, []);

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !statement.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Ensure first column (seq/#) is orderable
    if (normalizedCols[0]) {
      normalizedCols[0].orderable = true;
    }

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe statement (only include referenced keys + seq + void metadata)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (statement || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      if ("voided" in row) out.voided = row.voided;
      if ("result" in row) out.result = row.result;
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: { details: false },
        pageLength: pageSize || 10,
        lengthChange: false,
        autoWidth: false,
        ordering: true,
        orderSequence: ["asc", "desc"],
        order: initialOrder.length ? initialOrder : [[0, "asc"]],
        columnDefs: [
          {
            targets: 0,
            orderable: true,
            width: "9%",
            className: "dt-center",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 1,
            width: "32.8%",
            className: "dt-right",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 2,
            width: "20%",
            className: "dt-left",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 3,
            width: "17.1%",
            className: "min-desktop",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 4,
            width: "17.1%",
            className: "min-desktop",
            orderSequence: ["asc", "desc"]
          }
        ],
        //dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',

        dom: '<"dt-search"f>' + "rt" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",

        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        const col = dt.column(i);
        if (!col || !col.header()) return;

        const title = ($(col.header()).text() || "").trim();
        if (!title) return;

        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        const safeTitle = title
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");

        if (safeTitle == "Amount") {
          html += `
            <tr>
              <td class="ledger-detail-cell">
                <div class="ledger-detail-line">
                  <span class="ledger-detail-label">${safeTitle}:</span>
                  <div class="ledger-detail-value">${rendered}</div>
                </div>
              </td>
            </tr>`;
        } else {
          html += `
            <tr>
              <td class="ledger-detail-cell">
                <div class="ledger-detail-line-without-border">
                  <span class="ledger-detail-label">${safeTitle}:</span>
                  <div class="ledger-detail-value">${rendered}</div>
                </div>
              </td>
            </tr>`;
        }
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0 ledger-child-table">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0 ledger-child-table">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(
            `<table class="table table-sm mb-0 ledger-child-table">${details}</table>`
          )
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // Update toggle buttons after draw/order/search
    dt.on("order.dt search.dt draw.dt", () => {
      try {
        updateToggleButtons();
      } catch (e) {
        console.warn("Toggle update failed:", e);
      }
    });

    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, statement, pageSize, defaultExpand, isLoading]);

  const handlePageSizeChange = (event) => {
    let value = event.target.value;
    setPageSize(value);
    getHistory();
  };

  // Export to XLSX (full data)
  const handleExportXlsx = () => {
    // Use `title` instead of `label`, `data` instead of `field`
    const header = cols.map((c) => c.title);
    const rows = statement.map((r, i) => {
      return cols.map((c) => {
        if (c.data === "seq") return i + 1; // sequential numbering
        const val = r[c.data];
        if (c.data === "date") return new Date(val).toLocaleString();
        return val;
      });
    });

    const ws = utils.aoa_to_sheet([header, ...rows]);
    ws["!cols"] = cols.map(() => ({ wch: 20 }));

    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Transactions");
    writeFile(wb, "transactions.xlsx");
  };

  // Export to PDF (full data)
  const handleExportPdf = () => {
    const doc = new jsPDF("landscape");

    const headers = [cols.map((c) => c.title)];
    const rows = statement.map((r, i) => {
      return cols.map((c) => {
        if (c.data === "seq") return i + 1;
        const val = r[c.data];
        if (c.data === "date") return new Date(val).toLocaleString();
        return val;
      });
    });

    autoTable(doc, {
      head: headers,
      body: rows,
      startY: 20
    });

    doc.save("transactions.pdf");
  };

  // Print (full data)
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    contentRef: printRef,
    documentTitle: "Transactions",
    // page styling for print
    pageStyle: `
      @page { margin: 16mm; }
      body { -webkit-print-color-adjust: exact; }
      table { width: 100%; border-collapse: collapse; }
      th, td { border: 1px solid #dee2e6; padding: 6px 8px; }
      thead th { background: #f8f9fa; }
    `
  });

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);

  function PrintableTable({ data }) {
    return (
      <table className="table table-striped account-statement-print-table">
        <thead>
          <tr>
            {cols.map((c) => (
              <th key={c.data}>{c.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((r, i) => (
            <tr key={i}>
              {cols.map((c) => {
                let val;
                if (c.data === "seq") val = i + 1;
                else if (c.data === "date")
                  val = new Date(r[c.data]).toLocaleString();
                else val = r[c.data];

                const amountCell =
                  c.data === "amount"
                    ? {
                        className: r.amount < 0 ? "text-danger" : "text-success"
                      }
                    : {};

                return (
                  <td key={c.data} {...amountCell}>
                    {val}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  function toLocalString(d) {
    const pad = (x) => String(x).padStart(2, "0");
    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    );
  }

  const getHistory = useCallback(async () => {
    // Prevent multiple simultaneous requests
    console.log("Trying to fetch account statement");
    if (loadingRef.current) return;

    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);

    //setIsLoading(true);
    loadingRef.current = true;

    try {
      const response = await axiosInstance.post("/account-statement", {
        frm,
        til
      });

      console.log("account-statement->", response);

      // Small delay to ensure proper cleanup of previous DataTable
      setTimeout(() => {
        setStatement(response.data.history || []);
        setUniqueGridKey(Date.now());
        setIsLoading(false);
        loadingRef.current = false;
      }, 100);

      console.log("Account Statement Response:", response.data);
    } catch (error) {
      console.error("Error fetching account statement:", error);
      setIsLoading(false);
      loadingRef.current = false;
      setStatement([]);
    }
  }, [startDate, endDate]);

  //Get Event Details By CatMid
  useEffect(() => {
    getHistory();
  }, []); // Empty dependency array

  return (
    <ClientLayout>
      <div className="content-wrap body">
        <div className="table-wrap">
          <div className="row">
            <div className="col-md-12" style={{ marginBottom: "0px" }}>
              <div className="card" style={{ marginBottom: "8px" }}>
                <div className="card-header">
                  <i className="fa fa-align-justify"></i>Report Filter
                </div>
                <div className="card-body">
                  <form
                    id="ReportFilterForm"
                    className="form-inline"
                    method="get"
                  >
                    <div
                      className="row"
                      style={{ textAlignLast: "justify", padding: "10px" }}
                    >
                      <div className="col-12 col-md-5">
                        <Bootstrap4DatePickerComponent
                          pickerId="ReportFrom"
                          inputId="DisplayFrom"
                          defaultDate={startDate}
                          setSelectedDate={startDateSet}
                        />
                      </div>
                      <strong style={{ margin: "auto" }}>&nbsp;-&nbsp;</strong>
                      <div className="col-12 col-md-5">
                        <Bootstrap4DatePickerComponent
                          pickerId="ReportTo"
                          inputId="DisplayTo"
                          defaultDate={endDate}
                          setSelectedDate={endDateSet}
                        />
                      </div>
                      <div className="form-group editsbmtbtn">
                        <label className="mx-1"> </label>
                        <button
                          className="btn btn-primary"
                          onClick={() => getHistory()}
                          style={{
                            backgroundColor: "#00b181",
                            border: "none",
                            padding: "0.375rem 0.85rem"
                          }}
                          type="button"
                        >
                          <strong>Submit</strong>
                        </button>
                      </div>
                    </div>
                    <div className="row col-12"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" id="pldetail" style={{ marginTop: "0px" }}>
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <i className="fa fa-align-justify"></i>
                Account Ledger
              </div>

              <div className="">
                <div id="ahistory">
                  <div
                    id="tableLedger_wrapper"
                    className="dataTables_wrapper no-footer py-4 px-2"
                  >
                    <div className="row actionBtn">
                      <div className="col-12 col-sm-2">
                        <div
                          className="dataTables_length"
                          id="tableLedger_length"
                        >
                          <label>
                            <select
                              name="tableLedger_length"
                              aria-controls="tableLedger"
                              className="form-control d-inline-block w-auto"
                              onChange={handlePageSizeChange}
                            >
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>{" "}
                            entries per page
                          </label>
                        </div>
                      </div>
                      <div
                        className="col-12 col-md-5 col-sm-12"
                        style={{ textAlignw: "center" }}
                      >
                        <div
                          className="dt-buttons btn-group btn-group-sm 00"
                          style={{ width: "auto !important" }}
                        >
                          {" "}
                          <button
                            className="dt-button buttons-print px-5 rounded-left"
                            tabindex="0"
                            aria-controls="tableLedger"
                            type="button"
                            title="Copy"
                            style={{ border: "0px" }}
                            onClick={handlePrint}
                          >
                            <span>
                              <i className=""> Print</i>
                            </span>
                          </button>{" "}
                          <button
                            className="dt-button buttons-excel buttons-html5 px-5"
                            tabindex="0"
                            aria-controls="tableLedger"
                            type="button"
                            style={{ border: "0px" }}
                            title="Excel"
                            onClick={handleExportXlsx}
                          >
                            <span>
                              <i className=""> Excel</i>
                            </span>
                          </button>{" "}
                          <button
                            className="dt-button buttons-pdf buttons-html5 px-5 rounded-right"
                            tabindex="0"
                            aria-controls="tableLedger"
                            type="button"
                            style={{ border: "0px" }}
                            title="PDF"
                            onClick={handleExportPdf}
                          >
                            <span>
                              <i className=""> PDF</i>
                            </span>
                          </button>{" "}
                        </div>
                      </div>

                      {/* Hidden print area */}
                      <div style={{ display: "none" }}>
                        <div ref={printRef}>
                          <h3>Transactions</h3>
                          <PrintableTable data={statement} />
                        </div>
                      </div>
                    </div>

                    <div>
                      {statement.length === 0 ? (
                        <p className="text-center mt-3 text-muted">
                          {/*No records found for the selected period.*/}
                        </p>
                      ) : (
                        <div
                          className="table-responsive p-1"
                          key={uniqueGridKey}
                        >
                          <table
                            ref={gridTableRef}
                            className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              <tr>
                                {cols.map((c) => (
                                  <th key={c.data || c.title}>{c.title}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody />
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
      .rdt_Pagination {
        justify-content: flex-start; /* left */
        /* center */
        justify-content: center;
        /* right */
        justify-content: flex-end;
      }
  .table { width: 100% !important; }
  #tableLedger_wrapper .table-responsive {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .table.table-striped td, .table.table-striped th {
    padding: 6px 8px !important;
    font-size:17px;
    white-space: nowrap;
    vertical-align: middle;
  }
  table.table-sm td { padding: 4px 6px !important; }
  #tableLedger_wrapper tr.shown + tr > td {
    background-color: #ffffff !important;
  }
  .seq-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    margin: 0 auto;
  }
  .seq-cell .seq-number { flex: 0 0 auto; }
  /* --- Date cell: desktop = single line, tablet = two lines, mobile = current --- */
  .date-cell-wrap {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.3em;
    width: 100%;
    text-align: right;
    line-height: 1.3;
    white-space: nowrap;
  }
  .date-part { flex: 0 0 auto; }
  .date-time-block {
    flex: 0 0 auto;
    white-space: nowrap;
  }
  .date-time, .date-meridiem { display: inline; }

  /* Tablet (641px – 1024px): date on line 1, time+meridiem on line 2 */
  @media screen and (min-width: 641px) and (max-width: 1024px) {
    .date-cell-wrap {
      flex-direction: column;
      align-items: flex-end;
      gap: 0;
      white-space: normal;
    }
    .date-part { display: block; width: 100%; text-align: right; }
    .date-time-block { display: block; width: 100%; text-align: right; }
  }

  /* Mobile (≤640px): each piece on its own line */
  @media screen and (max-width: 640px) {
 
    .date-cell-wrap {
      flex-direction: column;
      align-items: flex-end;
      gap: 0;
      white-space: normal;
    }
    .date-part { display: block; width: 100%; text-align: right; }
    .date-time-block { display: block; width: 100%; text-align: right; }
    .date-time  { display: block; width: 100%; text-align: right; }
    .date-meridiem { display: block; width: 100%; text-align: right; }
  }

  /* DataTables 2: force right-align on Date column (th + td) */
  #tableLedger_wrapper table.dataTable thead th:nth-child(2),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(2),
  #tableLedger_wrapper table.dataTable th.dt-right,
  #tableLedger_wrapper table.dataTable td.dt-right {
    text-align: right !important;
    vertical-align: middle !important;
  }
  /* DataTables 2 wraps header title in a flex row; push title to the right */
  #tableLedger_wrapper table.dataTable thead th:nth-child(2) div.dt-column-header,
  #tableLedger_wrapper table.dataTable th.dt-right div.dt-column-header {
    justify-content: flex-end !important;
    flex-direction: row-reverse !important;
  }
  #tableLedger_wrapper table.dataTable thead th div.dt-column-header {
    flex-direction: row !important;
  }
  /* Override the generic rule above only for col 2 */
  #tableLedger_wrapper table.dataTable thead th:nth-child(2) div.dt-column-header {
    flex-direction: row-reverse !important;
  }
  .toggle-row {
    border: none;
    outline: none;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    line-height: 1;
    box-shadow: none;
    -webkit-tap-highlight-color: transparent;
  }
  .toggle-row:focus,
  .toggle-row:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
  .toggle-closed { background-color: #28a745; }
  .toggle-open { background-color: #dc3545; }
  .toggle-row:active { transform: scale(0.94); }

  /* Hide DataTables responsive default +/- control; we use .toggle-row instead */
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
    display: none !important;
    content: none !important;
  }
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child {
    padding-left: 8px !important;
    padding-right: 8px !important;
    cursor: default;
  }
  .dt-info { float:none; text-align:left; }
  .dt-paging-button { margin-left:0 !important; padding: 0 !important; }
  .dt-paging { text-align:center !important;float:right }
  .pagination { display:block !important; }

  /* Print preview table (same page): plain white rows — avoids removed global transparent hacks */
  .account-statement-print-table tbody tr,
  .account-statement-print-table tbody td {
    background-color: #ffffff !important;
  }

  .toggle-row { width:15px; height:15px; margin-left:2px; }

  /* Ledger: all data rows #FFFFFF (overrides Bootstrap / DataTables cell backgrounds) */
  #tableLedger_wrapper table.dataTable tbody > tr:not(.child),
  #tableLedger_wrapper table.dataTable tbody > tr:not(.child) > td {
    background-color: #ffffff !important;
  }

  /* Ledger: narrower Date, wider Description */
  #tableLedger_wrapper .table-responsive > table.dataTable {
    table-layout: fixed;
    width: 100% !important;
  }
  #tableLedger_wrapper table.dataTable thead th:nth-child(2),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(2) {
    box-sizing: border-box;
    white-space: nowrap;
  }
  /* Amount & Balance: right-aligned to match screenshot */
  #tableLedger_wrapper table.dataTable thead th:nth-child(4),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(4),
  #tableLedger_wrapper table.dataTable thead th:nth-child(5),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(5) {
    text-align: right !important;
    white-space: nowrap;
  }
  #tableLedger_wrapper table.dataTable thead th:nth-child(3),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(3) {
    min-width: 0;
    box-sizing: border-box;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    vertical-align: middle !important;
  }
  #tableLedger_wrapper table.dataTable tbody td:nth-child(3) a {
    white-space: normal !important;
    word-break: break-word;
  }

  #tableLedger_wrapper table.ledger-child-table {
    width: 48% !important;
    table-layout: fixed;
    margin: 0 !important;
     
  }

  #tableLedger_wrapper table.dataTable tbody > tr:not(.child), #tableLedger_wrapper table.dataTable tbody > tr:not(.child) > td {
    background-color: #ffffff !important;
    border-bottom: solid 0px red;
}
  #tableLedger_wrapper td.ledger-detail-cell {
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: 0px solid #eee !important;
    //padding: 1px 1px !important;
    padding: 4px 0px !important;
    vertical-align: middle !important;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    text-align: left;
  }
  /* Mobile detail rows: "Heading: value" on one line (wraps when long) */
  #tableLedger_wrapper .ledger-detail-line {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-start;
    gap: 0 0.35rem;
    line-height: 1.4;
    border-bottom:solid 1px #efefef;
    height:30px;
  }

  #tableLedger_wrapper .ledger-detail-line-without-border {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-start;
    gap: 0 0.35rem;
    line-height: 1.4;
    
  }
  #tableLedger_wrapper .ledger-detail-label {
    font-weight: 700 !important;
    color: #000 !important;
    font-size: 0.95rem !important;
    flex: 0 0 auto;
    border-bottom: 0px solid red;
    margin-bottom: 0 !important;
  }
  #tableLedger_wrapper .ledger-detail-value {
    font-size: 0.95rem;
    color: #212529;
    flex: 1 1 auto;
    min-width: 0;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    text-align: right;
  }

  #tableLedger_wrapper .ledger-detail-value span {
    
   border-bottom: 0px solid red;
  } 
  #tableLedger_wrapper .ledger-detail-value a {
    white-space: normal !important;
    word-break: break-word;
  }

  .dt-search { float:right; padding-right:10px; }
  .dt-search .form-control{
    border: 1px solid #ced4da;
    margin-bottom:5px;
    background-color: #ffffff;
    color: #212529;
  }

  .ledger-row-voided,
  .ledger-row-voided:hover {
    text-decoration: line-through !important;
    opacity: 0.65;
    color: #6c757d !important;
  }

  .actionBtn {
    position: absolute;
    width: 100%;
    margin-top: 0px;
    z-index: 12;
    margin-left: 1px;
    /* Let clicks reach DT search where this row has no controls */
    pointer-events: none;
  }
  .actionBtn select,
  .actionBtn button,
  .actionBtn label,
  .actionBtn .dt-buttons,
  .actionBtn .dataTables_length {
    pointer-events: auto;
  }

  /* Keep DT search above the action row and clickable */
  #tableLedger_wrapper .dt-search,
  #tableLedger_wrapper .dataTables_filter {
    position: relative;
    z-index: 11;
    pointer-events: auto;
  }

  /* Report filter — match legacy BPEXCH Account Ledger */
  #ReportFilterForm .datee,
  #ReportFilterForm .datetimepicker-input {
    background-color: #ffffff !important;
    color: #212529;
    font-size: 1rem;
  }
  #ReportFilterForm .input-group.date {
    width: 100%;
    flex-wrap: nowrap;
  }
  #ReportFilterForm .input-group .form-control {
    border: 1px solid #ced4da;
    border-right: 0;
    border-radius: 0.25rem 0 0 0.25rem;
    height: calc(1.5em + 0.75rem + 2px);
  }
  #ReportFilterForm .input-group-append .input-group-text {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-left: 0;
    border-radius: 0 0.25rem 0.25rem 0;
    cursor: pointer;
    color: #495057;
  }
  #ReportFilterForm .input-group-append .input-group-text:hover {
    background-color: #dde2e6;
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget {
    z-index: 1050 !important;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget table td.active,
  #ReportFilterForm .bootstrap-datetimepicker-widget table td.active:hover,
  #ReportFilterForm .bootstrap-datetimepicker-widget table td span.active {
    background-color: #00b181 !important;
    color: #fff !important;
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget table td.today:before {
    border-bottom-color: #00b181;
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
    background: #e9ecef;
  }
  @media screen and (max-width: 635px) {
    #ReportFilterForm .editsbmtbtn {
      margin: auto;
      margin-right: 15px;
    }
  }

  /* MOBILE ONLY FIXES */
  @media screen and (max-width: 640px) {

    .dt-info { float:none; text-align:center; }

    .table-wrap,
    #pldetail {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }

    #tableLedger_wrapper .table-responsive > table.dataTable {
      width: 90% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    #tableLedger_wrapper table.dataTable thead th:nth-child(1),
    #tableLedger_wrapper table.dataTable tbody td:nth-child(1) {
      width: 12% !important;
    }

    #tableLedger_wrapper table.dataTable thead th:nth-child(2),
    #tableLedger_wrapper table.dataTable tbody td:nth-child(2) {
      width: 8.98% !important;
      min-width: 0 !important;
      max-width: none !important;
    }

    #tableLedger_wrapper td.ledger-detail-cell {
      //padding-left: calc(12% + 8.98%) !important;
      padding-left: 0px;
    }

    .dt-paging { 
      float:unset;
    }

    #tableLedger_wrapper table.dataTable thead th:nth-child(3),
    #tableLedger_wrapper table.dataTable tbody td:nth-child(3) {
      width: 79.02% !important;
      min-width: 0 !important;
    }

    #ReportFilterForm .form-group {
      width: 100% !important;
      margin-bottom: 0;
    }
    #ReportFilterForm .input-group {
      width: 100% !important;
      max-width: 100% !important;
    }
    #ReportFilterForm .input-group .form-control {
      flex: 1 1 auto;
      min-width: 0;
      width: 1%;
    }

    #ReportFilterForm .editsbmtbtn {
      width: 100% !important;
      display: flex !important;
      justify-content: flex-end !important;
      align-items: center !important;
      margin-top: 0.5rem;
    }
    #ReportFilterForm .editsbmtbtn .btn {
      margin-right: 20px;
    }

    .actionBtn {
      width: 100%;
      margin-top: 0px;
      position: relative;
    }

    .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }

    .dataTable {
      margin-top:10px !important;
    }

    .table-responsive {
      margin-top:0px !important;
    }

    .dt-buttons {
      margin: 0 auto !important;
      float: none !important;
      width: auto !important;
      display: flex !important;
      justify-content: center;
    }
      
  }
        .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }
      @media screen and (max-width: 640px) {
  /* Make the top area stack nicely */
  .top.d-flex {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  /* Center the search container */
  .dt-search {
    display: flex !important;
    justify-content: center !important; /* center horizontally */
    width: 100% !important;
    margin: 8px 0 !important;
    padding: 0 12px;
    box-sizing: border-box;
  }

  /* Ensure the label + input stay inline and centered */
  .dt-search .dataTables_filter,
  .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    justify-content: center;
    width: auto !important;
    margin: 0;
  }

  /* Limit input width so it doesn't push other controls */
  .dt-search input[type="search"],
  .dataTables_filter input[type="search"] {
    width: 160px !important;
    max-width: 80% !important;
    display: inline-block !important;
    margin: 0 !important;
    border: 1px solid #ced4da !important;
    background-color: #ffffff !important;
    color: #212529 !important;
  }
    .dt-container {
      margin-top:0px !important;
    }
    }
    .dataTable {
    margin-top:15px;
    }

    #tableLedger_wrapper .ledger-detail-label {
      font-weight: 700 !important;
      color: #000 !important;
      font-size: 0.95rem !important;
      flex: 0 0 auto;
      border-bottom: 0px solid red;
      margin-bottom: 0 !important;
  }

    
`}</style>
    </ClientLayout>
  );
};

export default AccountStatement;
